import React from 'react';
import { Button, makeStyles } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { UserInfoWithLzPzus } from 'api';
import { Logout } from 'assets/svg';
import HeaderStore from 'stores/HeaderStore';
import { logout } from 'common/utils/roles';
import { DrawerContainer } from 'components/layout/Drawer';
import { HeaderInformation } from '../HeaderInformation/HeaderInformation';

export interface Menu {
  value: string;
  label: string;
  to: string;
  visible: boolean;
  subMenu?: Omit<Menu, 'subMenu'>[];
  icon?: any;
}

interface IProp {
  user: UserInfoWithLzPzus;
}

const useStyle = makeStyles(theme => ({
  root: {
    '& .MuiDrawer-paper': {
      position: 'relative',
      marginTop: 64,
      padding: 16,
      paddingBottom: 32,
      maxWidth: 260,
      boxShadow: 'none',
    },
  },
  mobileBtn: {
    boxShadow: 'none',
    padding: 11,
    fontSize: 14,
    borderRadius: 8,
    textTransform: 'none',
  },
  newDesignBtn: {
    position: 'sticky',
    bottom: 64,
    color: '#fff',
    backgroundColor: '#333',
    width: '100%',

    '&:hover': {
      backgroundColor: '#6366F1',
      color: theme.palette.common.white,
      boxShadow: 'none',
    },
  },
  logoutBtn: {
    color: '#333',
    backgroundColor: '#F1F5F9',
    marginTop: 24,
    '&:hover': {
      color: '#6366F1',
      backgroundColor: '#F1F5F9',
      boxShadow: 'none',
    },
  },
}));

export const MobileMenu: React.FC<IProp> = observer(({ user }) => {
  const classes = useStyle();
  return (
    <>
      <DrawerContainer
        className={classes.root}
        backdropInvisible
        anchor='left'
        open={HeaderStore.isMainNavOpened}
        onClose={HeaderStore.toggleIsMainNavOpened}
      >
        <HeaderInformation user={user} />
        <Button
          variant='contained'
          className={`${classes.logoutBtn} ${classes.mobileBtn}`}
          onClick={logout}
          startIcon={<Logout style={{ marginLeft: 6, width: 20 }} />}
        >
          Выход из системы
        </Button>
      </DrawerContainer>
    </>
  );
});
